import React from "react";
import { Tooltip, UserIcon } from "../../../../../shared/infrastructure";

type OfferCardOpsUsersProps = {
  opsUser: string;
  tooltipText: string;
};

export const OfferCardOpsUsers = ({
  opsUser,
  tooltipText,
}: OfferCardOpsUsersProps): React.ReactElement => {
  return (
    <Tooltip text={tooltipText}>
      <div className="relative flex items-center gap-1 text-[10px] font-[300] capitalize text-[#484848]">
        <UserIcon className="text-black" />
        <span className="ml-[2px] overflow-hidden text-ellipsis whitespace-nowrap capitalize">
          {opsUser}
        </span>
      </div>
    </Tooltip>
  );
};
